<div class="download-dialog">
  <div class="dialog-header">
    <div class="header-content">
      <mat-icon class="header-icon">cloud_download</mat-icon>
      <div>
        <h2 class="dialog-title">Download Documents</h2>
        <p class="dialog-subtitle">{{ data.confirmedName }} ({{ data.pan }})</p>
      </div>
    </div>
    <button class="close-btn" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">
    <!-- MCA Documents Section -->
    <div class="section" *ngIf="data.mcaDocuments">
      <div class="section-header">
        <div class="section-title-row">
          <mat-icon class="section-icon mca">business</mat-icon>
          <h3 class="section-title">MCA Documents</h3>
        </div>
        <span class="status-badge" [ngClass]="mcaStatus">
          {{ mcaStatus | titlecase }}
        </span>
      </div>

      <p class="section-message">{{ data.mcaDocuments.message }}</p>

      <div class="documents-list" *ngIf="hasMcaDocuments">
        <div class="document-item" *ngFor="let doc of data.mcaDocuments.documents">
          <div class="doc-info">
            <mat-icon class="doc-icon" [ngClass]="doc.mimeType === 'application/zip' ? 'zip' : 'pdf'">
              {{ getFileIcon(doc.mimeType) }}
            </mat-icon>
            <div class="doc-details">
              <span class="doc-name">{{ doc.documentName }}</span>
              <span class="doc-meta">
                {{ doc.category || doc.typeOfDocument }} • {{ formatFileSize(doc.fileSize) }}
              </span>
            </div>
          </div>
          <button class="download-btn" (click)="downloadDocument(doc)">
            <mat-icon>download</mat-icon>
          </button>
        </div>
      </div>

      <div class="no-documents" *ngIf="!hasMcaDocuments && mcaStatus !== 'completed'">
        <mat-icon>hourglass_empty</mat-icon>
        <span>Documents not yet available</span>
      </div>
    </div>

    <!-- Legal Check Documents Section -->
    <div class="section" *ngIf="data.legalCheckDocuments">
      <div class="section-header">
        <div class="section-title-row">
          <mat-icon class="section-icon legal">gavel</mat-icon>
          <h3 class="section-title">Legal Check Documents</h3>
        </div>
        <span class="status-badge" [ngClass]="legalStatus">
          {{ legalStatus | titlecase }}
        </span>
      </div>

      <p class="section-message">{{ data.legalCheckDocuments.message }}</p>

      <!-- Risk Info -->
      <div class="risk-info" *ngIf="data.legalCheckDocuments.riskType">
        <div class="risk-badge" [ngClass]="data.legalCheckDocuments.riskType === 'No Risk' ? 'no-risk' : 'has-risk'">
          <mat-icon>{{ data.legalCheckDocuments.riskType === 'No Risk' ? 'check_circle' : 'warning' }}</mat-icon>
          <span>{{ data.legalCheckDocuments.riskType }}</span>
        </div>
        <p class="risk-summary" *ngIf="data.legalCheckDocuments.riskSummary">
          {{ data.legalCheckDocuments.riskSummary }}
        </p>
      </div>

      <div class="documents-list" *ngIf="hasLegalDocuments">
        <div class="document-item" *ngFor="let doc of data.legalCheckDocuments.documents">
          <div class="doc-info">
            <mat-icon class="doc-icon pdf">{{ getFileIcon(doc.mimeType) }}</mat-icon>
            <div class="doc-details">
              <span class="doc-name">{{ doc.documentName }}</span>
              <span class="doc-meta">{{ formatFileSize(doc.fileSize) }}</span>
            </div>
          </div>
          <button class="download-btn" (click)="downloadDocument(doc)">
            <mat-icon>download</mat-icon>
          </button>
        </div>
      </div>

      <div class="no-documents" *ngIf="!hasLegalDocuments && legalStatus !== 'completed'">
        <mat-icon>hourglass_empty</mat-icon>
        <span>Documents not yet available</span>
      </div>
    </div>

    <!-- No Documents Available -->
    <div class="empty-state" *ngIf="!data.mcaDocuments && !data.legalCheckDocuments">
      <mat-icon>folder_off</mat-icon>
      <p>No documents available for this report</p>
    </div>
  </div>
</div>

